import { useState } from 'react'

import { Button, Field, Stack, Text } from '@taro/design'

import type { Spread } from '../../api'
import styles from './reading.module.css'

interface Props {
  spread: Spread
  balance: number
  busy: boolean
  error: string | null
  onStart: (question: string) => void
  onBack: () => void
}

/**
 * Расклад до тасовки: из чего он состоит и что человек хочет спросить.
 *
 * Список позиций показывается ДО оплаты. Это и есть ответ на «чем один
 * расклад отличается от другого» — не числом карт, а тем, на какие
 * вопросы отвечает каждое место.
 */
export function SpreadIntro({ spread, balance, busy, error, onStart, onBack }: Props) {
  const [question, setQuestion] = useState('')

  const enough = spread.price <= balance

  return (
    <Stack gap={5}>
      <button type="button" className={styles.back} onClick={onBack}>
        ← Все расклады
      </button>

      <Stack gap={2}>
        <Text variant="display-m" as="h2">
          {spread.title}
        </Text>
        <Text variant="body-m" tone="tertiary" measure>
          {spread.description}
        </Text>
      </Stack>

      <Stack gap={2}>
        <Text variant="overline" tone="tertiary">
          Места расклада
        </Text>
        <ol className={styles.positions}>
          {spread.positions.map((p) => (
            <li key={p.idx} className={styles.position}>
              <span className={styles.positionIdx}>{p.idx + 1}</span>
              <Text variant="body-m">{p.title}</Text>
            </li>
          ))}
        </ol>
      </Stack>

      <Field
        label="Вопрос"
        multiline
        rows={3}
        maxLength={500}
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        hint="Можно не задавать — тогда расклад ответит на то, что сейчас важнее всего."
      />

      {error ? (
        <Text variant="body-s" tone="danger">
          {error}
        </Text>
      ) : null}

      <Button fullWidth size="lg" loading={busy} disabled={!enough} onClick={() => onStart(question)}>
        {spread.price === 0 ? 'Взять колоду' : `Взять колоду · ${spread.price}`}
      </Button>

      {enough ? null : (
        <Text variant="body-s" tone="tertiary">
          Не хватает {spread.price - balance}. Заходи завтра — за вход начисляем.
        </Text>
      )}
    </Stack>
  )
}
